import React, { useState, useEffect } from 'react';
import { Building2, Tag, FileText, CheckCircle2, X, UploadCloud, Send , Loader2 , MapPin } from 'lucide-react';
import toast from 'react-hot-toast';
import LeadProfile from './components/LeadProfile';
import { useAuth } from '../../context/AuthContext';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { sortStatuses } from '../../utils/statusUtils';
import Dropdown from '../../components/Dropdown';
import { API_URL, BASE_URL } from '../../utils/api';

const AddLead = ({ onClose, initialData, isViewMode = false, onEdit, onDelete, onAction }) => {
  const { user: currentUser } = useAuth();
  
  const [shopName, setShopName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [contactPhone, setContactPhone] = useState('');
  const [contactEmail, setContactEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [address2, setAddress2] = useState('');
  const [city, setCity] = useState('Surat');
  const [state, setState] = useState('Gujarat');
  const [pincode, setPincode] = useState('');

  const [agencyType, setAgencyType] = useState('copy shop');
  const [isOtherAgencyType, setIsOtherAgencyType] = useState(false);
  const [otherAgencyType, setOtherAgencyType] = useState('');

  const [interestedType, setInterestedType] = useState('');
  const [machineType, setMachineType] = useState('');
  const [machineBrand, setMachineBrand] = useState('');
  const [otherInterest, setOtherInterest] = useState('');
  const [machineModel, setMachineModel] = useState('');
  
  const [assignee, setAssignee] = useState(currentUser?.name || '');
  const [status, setStatus] = useState('');
  const [customerType, setCustomerType] = useState('');
  const [leadSource, setLeadSource] = useState('Walk-in');
  const [notes, setNotes] = useState('');
  
  const [followUpDate, setFollowUpDate] = useState('');
  const [followUpTime, setFollowUpTime] = useState('');
  const [followUpDays, setFollowUpDays] = useState('');
  const [originalFollowUp, setOriginalFollowUp] = useState(null);
  const [followUpId, setFollowUpId] = useState(null);
  
  const [frontCard, setFrontCard] = useState(null);
  const [backCard, setBackCard] = useState(null);
  
  const [showBrochureModal, setShowBrochureModal] = useState(false);
  const [createdLead, setCreatedLead] = useState(null);

  // Dynamic master data state
  const [leadTypes, setLeadTypes] = useState([]);
  const [machines, setMachines] = useState([]);
  const [leadSources, setLeadSources] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const [users, setUsers] = useState([]);
  const [customerTypes, setCustomerTypes] = useState([]);
  
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [locationError, setLocationError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  
  useEffect(() => {
    

    const fetchMasters = async () => {
      try {
        const { default: api } = await import('../../utils/api');
        const [typesRes, machinesRes, sourcesRes, statusesRes, usersRes, customerTypesRes] = await Promise.all([
          api.get('/masters/lead-types').catch(() => ({ data: [] })),
          api.get('/masters/machines').catch(() => ({ data: [] })),
          api.get('/masters/lead-sources').catch(() => ({ data: [] })),
          api.get('/masters/status').catch(() => ({ data: [] })),
          api.get('/auth/users').catch(() => ({ data: [] })),
          api.get('/masters/customer-types').catch(() => ({ data: [] }))
        ]);
        setLeadTypes(typesRes.data.filter(t => t.status === 'Active'));
        setMachines(machinesRes.data.filter(m => m.status === 'Active' && m.name && m.name.trim() !== ''));
        
        const activeSources = sourcesRes.data.filter(s => s.status === 'Active');
        setLeadSources(activeSources);
        if (!initialData) {
          const walkin = activeSources.find(s => s.name.toLowerCase() === 'walk-in');
          if (walkin) setLeadSource(walkin.name);
        }

        const activeStatuses = sortStatuses(statusesRes.data.filter(s => s.status === 'Active'));
        setStatuses(activeStatuses);
        setUsers(usersRes.data.filter(u => u.role !== 'Admin' && u.status === 'Active'));
        setCustomerTypes(customerTypesRes.data.filter(c => c.status === 'Active'));
        
        if (!initialData && activeStatuses.length > 0) {
          const newStatus = activeStatuses.find(s => s.name.toLowerCase().includes('new')) || activeStatuses[0];
          setStatus(newStatus.name);
        }
        if (!initialData) {
          const activeCustomerTypes = customerTypesRes.data.filter(c => c.status === 'Active');
          const hotType = activeCustomerTypes.find(c => c.name.toLowerCase() === 'hot') || activeCustomerTypes[0];
          if (hotType) setCustomerType(hotType.name);
        }
      } catch (err) {
        console.error('Failed to fetch master data', err);
      }
    };
    fetchMasters();
  }, []);
  
  
  
  useEffect(() => {
    if (initialData) {
      setShopName(initialData.companyName || initialData.name || '');
      setContactPerson(initialData.contactPerson || initialData.contact || '');
      setContactPhone(initialData.contactPhone || '');
      setContactEmail(initialData.contactEmail || '');
      setPhone(initialData.phone || '');
      setEmail(initialData.email || '');
      setFrontCard(initialData.frontCard || null);
      setBackCard(initialData.backCard || null);
      let rawAddr1 = initialData.address || '';
      let rawAddr2 = initialData.address2 || '';
      const cleanAddr1 = rawAddr1.replace(/\s*\[GPS:.*?\]/gi, '').trim();
      const cleanAddr2 = rawAddr2.replace(/\s*\[GPS:.*?\]/gi, '').trim();
      setAddress(cleanAddr1);
      setAddress2(cleanAddr2);
      setCity(initialData.city || 'Surat');
      setState(initialData.state || 'Gujarat');
      setPincode(initialData.pincode || '');

      let latVal = initialData.latitude;
      let lngVal = initialData.longitude;
      if ((latVal === undefined || latVal === null || latVal === '') && rawAddr1) {
        const gpsMatch = rawAddr1.match(/\[GPS:\s*Lat:\s*([\d.-]+),\s*Lon:\s*([\d.-]+)\]/i);
        if (gpsMatch) {
          latVal = parseFloat(gpsMatch[1]);
          lngVal = parseFloat(gpsMatch[2]);
        }
      }
      if (latVal !== undefined && latVal !== null && latVal !== '') setLatitude(latVal);
      if (lngVal !== undefined && lngVal !== null && lngVal !== '') setLongitude(lngVal);

      setAgencyType(initialData.agencyType || 'copy shop');
      setIsOtherAgencyType(initialData.otherAgencyType ? true : false);
      setOtherAgencyType(initialData.otherAgencyType || '');
      
      setInterestedType(initialData.interestType || '');
      setMachineType(initialData.machineType || '');

      setMachineBrand(initialData.machineBrand || initialData.machine?.name || '');
      setMachineModel(initialData.machineModel || '');
      setStatus(initialData.status && initialData.status !== 'Unknown' ? (initialData.status.name || initialData.status) : '');
      setCustomerType(initialData.customerType || initialData.customerType?.name || '');
      setAssignee(initialData.assignee !== 'Unassigned' ? initialData.assignee : '');
      setLeadSource(initialData.source !== 'Unknown' ? (initialData.source?.name || initialData.source) : 'Walk-in');

      if (initialData.followups && initialData.followups.length > 0) {
        const validFollowups = initialData.followups.filter(f => f.type !== 'System');
        
        if (validFollowups.length > 0) {
          const now = new Date();
          const futureFollowups = validFollowups.filter(f => new Date(f.date) >= now);
          futureFollowups.sort((a, b) => new Date(a.date) - new Date(b.date));
          
          const targetFollowup = futureFollowups.length > 0 ? futureFollowups[0] : [...validFollowups].sort((a, b) => new Date(b.date) - new Date(a.date))[0];
          
          if (targetFollowup && targetFollowup.date) {
            const d = new Date(targetFollowup.date);
            setFollowUpDate(d);
            const hours = String(d.getHours()).padStart(2, '0');
            const mins = String(d.getMinutes()).padStart(2, '0');
            setFollowUpTime(`${hours}:${mins}`);
            setOriginalFollowUp(d.getTime());
            setFollowUpId(targetFollowup.id);
            
            const now = new Date();
            const diffTime = d - now;
            if (diffTime > 0) {
              const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
              setFollowUpDays(diffDays);
            } else {
              setFollowUpDays('');
            }
          }
        }
      }
    }
  }, [initialData]);

  // Handle calculation for follow up days
  const handleFollowUpDaysChange = (days) => {
    setFollowUpDays(days);
    if (days && !isNaN(days)) {
      const d = new Date();
      d.setDate(d.getDate() + parseInt(days));
      setFollowUpDate(d);
    } else {
      setFollowUpDate(null);
    }
  };

  const handleFollowUpDateChange = (date) => {
    setFollowUpDate(date);
    if (date) {
      const now = new Date();
      const diffTime = Math.abs(date - now);
      const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      setFollowUpDays(diffDays);
    } else {
      setFollowUpDays('');
    }
  };

  const handleInterestTypeChange = (val) => {
    setInterestedType(val);
    if (val === 'In Future') {
      const scheduleStatus = statuses.find(s => s.name.toLowerCase().includes('schedule'));
      if (scheduleStatus) setStatus(scheduleStatus.name);
    } else if (val === 'Not at all' || val === 'Not at all of use') {
      const lostStatus = statuses.find(s => s.name.toLowerCase().includes('lost'));
      if (lostStatus) setStatus(lostStatus.name);
    }
  };

  
  
  const handleSave = async (e) => {
    e.preventDefault();
    if (isViewMode) return;
        // Phone Validations
    const phoneRegex = /^\d{10}$/;
    if (phone && !phoneRegex.test(phone.replace(/\D/g, ''))) {
      toast.error('Agency phone number must be exactly 10 digits');
      return;
    }
    if (contactPhone && !phoneRegex.test(contactPhone.replace(/\D/g, ''))) {
      toast.error('Contact person phone number must be exactly 10 digits');
      return;
    }

    // Email Validations
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (email && !emailRegex.test(email)) {
      toast.error('Please enter a valid agency email address');
      return;
    }
    if (contactEmail && !emailRegex.test(contactEmail)) {
      toast.error('Please enter a valid contact person email address');
      return;
    }

    if (!interestedType) {
      toast.error('Please select an Interest Type');
      return;
    }

    setIsSubmitting(true);
    try {
      const { default: api } = await import('../../utils/api');
      
      const machineObj = machines.find(m => m.name === machineBrand);
      const sourceObj = leadSources.find(s => s.name === leadSource);
      const statusObj = statuses.find(s => s.name === status);
      const customerTypeObj = customerTypes.find(c => c.name === customerType);
      const userObj = users.find(u => u.name === assignee || u.name + ' (' + u.role + ')' === assignee);

      let finalFollowUpDate = null;
      if (followUpDate) {
        const d = new Date(followUpDate);
        if (followUpTime) {
          const [hours, minutes] = followUpTime.split(':');
          d.setHours(hours, minutes, 0, 0);
        }
        
        if (!initialData || d.getTime() !== originalFollowUp) {
          finalFollowUpDate = d.toISOString();
        }
      }

      let frontCardBase64 = frontCard;
      let backCardBase64 = backCard;

      const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });

      if (frontCard instanceof File) {
        frontCardBase64 = await toBase64(frontCard);
      }
      if (backCard instanceof File) {
        backCardBase64 = await toBase64(backCard);
      }

      const payload = {
        companyName: shopName,
        contactPerson: contactPerson,
        contactPhone: contactPhone,
        contactEmail: contactEmail,
        phone: phone,
        email: email,
        address: address,
        address2: address2,
        city: city,
        state: state,
        pincode: pincode,
        agencyType: agencyType,
        otherAgencyType: isOtherAgencyType ? otherAgencyType : null,
        interestType: interestedType,
        machineType: machineType,
        frontCard: frontCardBase64,
        backCard: backCardBase64,
        notes: notes,
        machineId: machineObj ? machineObj.id : null,
        machineModel: machineModel,
        leadSourceId: sourceObj ? sourceObj.id : null,
        statusId: statusObj ? statusObj.id : null,
        customerTypeId: customerTypeObj ? customerTypeObj.id : null,
        latitude,
        longitude,
        isCustomer: statusObj ? ['won', 'completed', 'complete'].includes(statusObj.name.toLowerCase()) : false,
        userId: userObj ? userObj.id : null,
        followUpDate: finalFollowUpDate,
        followUpTime: followUpTime || null,
        followUpId: followUpId
      };

      if (initialData && initialData.id) {
        await api.put(`/leads/${initialData.id}`, payload);
        toast.success('Lead updated successfully!');
        onClose(true);
      } else {
        const res = await api.post('/leads', payload);
        toast.success('Lead created successfully!');
        
        if (machineObj && machineObj.brochure) {
           setCreatedLead(res.data);
           setShowBrochureModal(true);
        } else {
           onClose(true);
        }
      }
      
    } catch (err) {
      console.error(err);
      toast.error('Failed to save lead');
    } finally {
      setIsSubmitting(false);
    }
  };

  const sendBrochureViaEmail = async () => {
    try {
      const { default: api } = await import('../../utils/api');
      await api.post(`/leads/${createdLead.id}/send-brochure`, { baseUrl: BASE_URL });
      toast.success('Brochure sent via Email successfully!');
      setShowBrochureModal(false);
      onClose(true);
    } catch (err) {
      toast.error('Failed to send brochure via Email');
    }
  };

  const sendBrochureViaWhatsApp = () => {
    const phone = createdLead?.contactPhone || createdLead?.phone || '';
    const cleanPhone = phone.replace(/\D/g, '');
    const finalPhone = cleanPhone.length === 10 ? `91${cleanPhone}` : cleanPhone;
    
    const machineObj = machines.find(m => m.name === machineBrand);
    let brochureLink = '';
    if (machineObj && machineObj.brochure) {
       const path = machineObj.brochure.startsWith('/') ? machineObj.brochure : `/${machineObj.brochure}`;
       brochureLink = `\n\nBrochure: ${BASE_URL}${path}`;
    }
    
    const name = createdLead?.contactPerson || createdLead?.companyName || 'Customer';
    const message = encodeURIComponent(`Hello ${name},\n\nThank you for visiting us! Here are the details for the ${machineBrand} ${machineModel} machine you inquired about.${brochureLink}\n\nPlease let us know if you have any questions.`);
    
    window.open(`https://wa.me/${finalPhone}?text=${message}`, '_blank');
    
    toast.success('Opened WhatsApp!');
    setShowBrochureModal(false);
    onClose(true);
  };

  if (isViewMode && initialData) {
    return <LeadProfile 
      lead={initialData} 
      onClose={onClose} 
      onEditLead={onEdit} 
      onDeleteLead={onDelete} 
      onActionLead={onAction} 
    />;
  }

  if (showBrochureModal) {
    return (
      <div style={{ padding: '3rem', textAlign: 'center' }}>
         <CheckCircle2 size={64} color="var(--color-primary)" style={{ margin: '0 auto 1rem auto' }} />
         <h2 className="text-2xl font-bold mb-4">Lead Created!</h2>
         <p className="mb-6">How would you like to send the brochure for the selected machine to the customer?</p>
         <div className="flex gap-4 justify-center">
            <button className="btn" style={{ border: '1px solid var(--color-border)' }} onClick={() => onClose(true)}>Skip</button>
            <button className="btn btn-primary flex items-center gap-2" onClick={sendBrochureViaEmail}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect width="20" height="16" x="2" y="4" rx="2"/><path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/></svg>
              Send via Email
            </button>
            <button className="btn flex items-center gap-2" style={{ backgroundColor: '#25D366', color: 'white', border: 'none' }} onClick={sendBrochureViaWhatsApp}>
              <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 21l1.65-3.8a9 9 0 1 1 3.4 3.4L3 21"/><path d="M9 10a.5.5 0 0 0 1 0V9a.5.5 0 0 0-1 0v1a5 5 0 0 0 5 5h1a.5.5 0 0 0 0-1h-1a.5.5 0 0 0 0 1"/></svg>
              Send via WhatsApp
            </button>
         </div>
      </div>
    );
  }

  return (
    <div style={{ width: '100%', display: 'flex', flexDirection: 'column' }}>
      <div 
        className="flex justify-between items-center" 
        style={{ 
          position: 'sticky', 
          top: 0, 
          backgroundColor: 'var(--color-bg-card)', 
          zIndex: 20, 
          padding: '2.5rem 2.5rem 1.5rem 2.5rem', 
          borderBottom: '1px solid var(--color-border)' 
        }}
      >
        <div>
          <div className="flex items-center" style={{ gap: '0.75rem' }}>
            <h2 className="text-2xl font-bold">{initialData ? 'Edit Lead' : 'Add New Lead'}</h2>
          </div>
        </div>
        <button type="button" className="btn text-muted" style={{ padding: '0.5rem', background: 'none', border: 'none' }} onClick={onClose} title="Close">
          <X size={24} />
        </button>
      </div>

      <div style={{ padding: '2rem 2.5rem 2.5rem 2.5rem' }}>
        <form onSubmit={handleSave} className="flex-col gap-8">
          <fieldset disabled={isViewMode} style={{ border: 'none', padding: 0, margin: 0 }}>
            {/* Section 1: Agency/Shop Details */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <Building2 size={22} color="var(--color-primary)" />
                <h3 className="text-xl font-semibold">Agency / Shop Details</h3>
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem', marginBottom: '1.5rem' }}>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Lead Source</label>
                  <Dropdown
                    placeholder="Select Source..."
                    value={leadSource}
                    onChange={(val) => setLeadSource(val)}
                    options={leadSources.map(s => ({ value: s.name, label: s.name }))}
                  />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Agency / Shop Type</label>
                  <Dropdown
                    placeholder="Select Type..."
                    value={agencyType}
                    onChange={(val) => {
                      setAgencyType(val);
                      if (val === 'other') setIsOtherAgencyType(true);
                      else setIsOtherAgencyType(false);
                    }}
                    options={[
                      { value: 'copy shop', label: 'Copy Shop' },
                      { value: 'other', label: 'Other' }
                    ]}
                  />
                </div>
                {isOtherAgencyType && (
                  <div>
                    <label className="text-sm font-semibold mb-2 block text-muted">Other Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                    <input type="text" className="input-field" required placeholder="Specify other type" value={otherAgencyType} onChange={e => setOtherAgencyType(e.target.value)} />
                  </div>
                )}
              </div>

              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Agency / Shop Name <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required placeholder="e.g. Acme Printing Shop" value={shopName} onChange={e => setShopName(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Phone Number <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="tel" className="input-field" required placeholder="+1 234 567 8900" value={phone} maxLength="10" onChange={e => setPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Email Address</label>
                  <input type="email" className="input-field" placeholder="email@example.com" value={email} onChange={e => setEmail(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Address Line 1</label>
                  <input type="text" className="input-field" placeholder="Street Address" value={address} onChange={e => setAddress(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Address Line 2</label>
                  <input type="text" className="input-field" placeholder="Apt, Suite, etc." value={address2} onChange={e => setAddress2(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">City</label>
                  <input type="text" className="input-field" value={city} onChange={e => setCity(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">State</label>
                  <input type="text" className="input-field" value={state} onChange={e => setState(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Pincode</label>
                  <input type="text" className="input-field" value={pincode} onChange={e => setPincode(e.target.value)} />
                </div>
              </div>
            </div>

            {/* Section 2: Contact Details */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <CheckCircle2 size={22} color="var(--color-primary)" />
                <h3 className="text-xl font-semibold">Contact Details</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Contact Person <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="text" className="input-field" required placeholder="Full Name" value={contactPerson} onChange={e => setContactPerson(e.target.value)} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Phone Number <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <input type="tel" className="input-field" required placeholder="+1 234 567 8900" value={contactPhone} maxLength="10" onChange={e => setContactPhone(e.target.value.replace(/\D/g, '').slice(0, 10))} />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Email Address</label>
                  <input type="email" className="input-field" placeholder="email@example.com" value={contactEmail} onChange={e => setContactEmail(e.target.value)} />
                </div>
              </div>
            </div>

            {/* Section 3: Product Interest */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <Tag size={22} color="var(--color-primary)" />
                <h3 className="text-xl font-semibold">Product Interest</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Interest Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Interest..."
                    value={interestedType}
                    onChange={handleInterestTypeChange}
                    options={[
                      { value: 'Interested in machine', label: 'Interested in machine' },
                      { value: 'In Future', label: 'In Future' },
                      { value: 'Not at all', label: 'Not at all' }
                    ]}
                  />
                </div>

                {(interestedType === 'Interested in machine' || interestedType === 'In Future') && (
                  <>
                    <div className="fade-in">
                      <label className="text-sm font-semibold mb-2 block text-muted">Machine Type</label>
                      <Dropdown
                        placeholder="Select Machine Type..."
                        value={machineType}
                        onChange={(val) => setMachineType(val)}
                        options={[
                          { value: 'rental', label: 'Rental Machine' },
                          { value: 'new', label: 'New Machine' }
                        ]}
                      />
                    </div>
                    <div className="fade-in">
                      <label className="text-sm font-semibold mb-2 block text-muted">Machine Brand <span style={{color: 'var(--color-danger)'}}>*</span></label>
                      <Dropdown
                        placeholder="Select Machine..."
                        value={machineBrand}
                        onChange={(val) => setMachineBrand(val)}
                        options={machines.map(m => ({ value: m.name, label: m.name }))}
                      />
                    </div>
                    <div className="fade-in">
                      <label className="text-sm font-semibold mb-2 block text-muted">Machine Model <span style={{color: 'var(--color-danger)'}}>*</span></label>
                      <input 
                        type="text" 
                        className="input-field"
                        value={machineModel}
                        onChange={(e) => setMachineModel(e.target.value)}
                        placeholder="e.g. IR 3225"
                        required
                      />
                    </div>
                  </>
                )}
              </div>
            </div>

            {/* Section 4: Tracking & Assignment */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <CheckCircle2 size={22} color="var(--color-primary)" />
                <h3 className="text-xl font-semibold">Tracking & Assignment</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Initial Status</label>
                  <Dropdown
                    placeholder="Select Status..."
                    value={status}
                    onChange={(val) => setStatus(val)}
                    options={statuses.map(s => ({ value: s.name, label: s.name }))}
                  />
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Assign To Executive</label>
                  <Dropdown
                    placeholder="Unassigned"
                    value={assignee || currentUser?.name || ''}
                    onChange={(val) => {
                      if (true || currentUser?.role === 'Admin') {
                        setAssignee(val);
                      }
                    }}
                    options={[
                      { value: '', label: 'Unassigned' },
                      ...(currentUser?.name && !users.some(u => u.name === currentUser.name) ? [{ value: currentUser.name, label: `${currentUser.name} (You)` }] : []),
                      ...users.map(u => ({ value: u.name, label: `${u.name} (${u.role})` }))
                    ]}
                  />
                </div>
                
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Customer Type <span style={{color: 'var(--color-danger)'}}>*</span></label>
                  <Dropdown
                    placeholder="Select Customer Type..."
                    value={customerType}
                    onChange={(val) => setCustomerType(val)}
                    options={customerTypes.map(c => ({ value: c.name, label: c.name }))}
                  />
                </div>
                
                {status && (status.toLowerCase().includes('schedule') || status.toLowerCase().includes('follow')) && (
                  <div className="fade-in" style={{ gridColumn: 'span 3', backgroundColor: '#f0f9ff', padding: '1.5rem', borderRadius: '8px', border: '1px solid #bae6fd' }}>
                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '1.5rem' }}>
                      <div>
                        <label className="text-sm font-semibold mb-2 block" style={{ color: '#0369a1' }}>Follow-up In (Days) <span style={{color: 'var(--color-danger)'}}>*</span></label>
                        <input 
                          type="number" 
                          className="input-field" 
                          placeholder="e.g. 10"
                          min="0"
                          value={followUpDays} 
                          onChange={(e) => handleFollowUpDaysChange(e.target.value)} 
                          required
                          style={{ backgroundColor: 'white' }}
                        />
                      </div>
                      <div>
                        <label className="text-sm font-semibold mb-2 block" style={{ color: '#0369a1' }}>Calculated Follow-up Date</label>
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            selected={followUpDate ? new Date(followUpDate) : null}
                            onChange={(date) => handleFollowUpDateChange(date)}
                            className="input-field"
                            dateFormat="dd/MM/yyyy"
                            placeholderText="DD/MM/YYYY"
                            minDate={new Date()}
                            style={{ backgroundColor: 'white' }}
                          />
                        </div>
                      </div>
                      <div>
                        <label className="text-sm font-semibold mb-2 block" style={{ color: '#0369a1' }}>Follow-up Time <span style={{color: 'var(--color-danger)'}}>*</span></label>
                        <div className="custom-datepicker-wrapper">
                          <DatePicker
                            selected={(() => {
                              if (!followUpTime) return null;
                              const d = new Date();
                              const [h, m] = followUpTime.split(':');
                              d.setHours(parseInt(h, 10), parseInt(m, 10), 0, 0);
                              return d;
                            })()}
                            onChange={(date) => {
                              if (date) {
                                const hours = String(date.getHours()).padStart(2, '0');
                                const mins = String(date.getMinutes()).padStart(2, '0');
                                setFollowUpTime(`${hours}:${mins}`);
                              } else {
                                setFollowUpTime('');
                              }
                            }}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="hh:mm aa"
                            className="input-field"
                            placeholderText="Select Time"
                            required
                            minTime={
                              followUpDate && new Date(followUpDate).setHours(0,0,0,0) === new Date().setHours(0,0,0,0)
                                ? new Date()
                                : new Date(new Date().setHours(0, 0, 0, 0))
                            }
                            maxTime={new Date(new Date().setHours(23, 59, 59, 999))}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>

            
            {/* Section 5: Visiting Card Images */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-6 border-b pb-3" style={{ borderColor: 'var(--color-border)' }}>
                <FileText size={22} color="var(--color-primary)" />
                <h3 className="text-xl font-semibold">Visiting Card (Optional)</h3>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1.5rem' }}>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Front Side Image</label>
                  <div style={{ border: '2px dashed var(--color-border)', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', backgroundColor: frontCard ? 'var(--color-primary-light)' : '#f8fafc', position: 'relative', overflow: 'hidden', transition: 'all 0.2s', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <input type="file" accept="image/*" onChange={(e) => setFrontCard(e.target.files[0])} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', zIndex: 10 }} />
                    {frontCard ? (
                      <img 
                        src={typeof frontCard === 'string' ? frontCard : URL.createObjectURL(frontCard)} 
                        alt="Front Card" 
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', zIndex: 1 }} 
                      />
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                        <UploadCloud size={24} color={'var(--color-text-muted)'} />
                        <span style={{ fontSize: '0.875rem', fontWeight: '500', color: 'var(--color-text-main)' }}>
                          Click to upload front side
                        </span>
                      </div>
                    )}
                  </div>
                </div>
                <div>
                  <label className="text-sm font-semibold mb-2 block text-muted">Back Side Image</label>
                  <div style={{ border: '2px dashed var(--color-border)', borderRadius: '12px', padding: '1.5rem', textAlign: 'center', backgroundColor: backCard ? 'var(--color-primary-light)' : '#f8fafc', position: 'relative', overflow: 'hidden', transition: 'all 0.2s', height: '150px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <input type="file" accept="image/*" onChange={(e) => setBackCard(e.target.files[0])} style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', opacity: 0, cursor: 'pointer', zIndex: 10 }} />
                    {backCard ? (
                      <img 
                        src={typeof backCard === 'string' ? backCard : URL.createObjectURL(backCard)} 
                        alt="Back Card" 
                        style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain', zIndex: 1 }} 
                      />
                    ) : (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '0.5rem' }}>
                        <UploadCloud size={24} color={'var(--color-text-muted)'} />
                        <span style={{ fontSize: '0.875rem', fontWeight: '500', color: 'var(--color-text-main)' }}>
                          Click to upload back side
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Section 6: Additional Notes */}
            <div className="mb-8">
              <div className="flex items-center gap-2 mb-4">
                <FileText size={20} color="var(--color-text-muted)" />
                <h3 className="text-lg font-semibold">Additional Notes</h3>
              </div>
              <textarea className="input-field w-full" rows="3" placeholder="Add any initial conversation notes, special requirements, or follow-up instructions here..." value={notes} onChange={e => setNotes(e.target.value)}></textarea>
            </div>
          </fieldset>

          <div className="flex justify-end gap-3 mt-4 pt-6 border-t" style={{ borderColor: 'var(--color-border)' }}>
            <button type="button" className="btn text-muted" onClick={onClose} style={{ padding: '0.875rem 2rem', fontSize: '1rem', borderRadius: 'var(--border-radius-md)', backgroundColor: 'white', border: '1px solid var(--color-border)' }}>
              Cancel
            </button>
            <button type="submit" disabled={isSubmitting} className="btn btn-primary" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', padding: '0.875rem 2.5rem', fontSize: '1rem', borderRadius: 'var(--border-radius-md)' }}>
              {isSubmitting && <Loader2 size={18} className="spinner-icon" />}
              {isSubmitting ? 'Saving...' : (initialData ? 'Save Changes' : 'Create Lead')}
            </button>
          </div>
        </form>
      </div>
      
      <style>{`
        .fade-in {
          animation: fadeIn 0.3s ease-in-out;
        }
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(-5px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  );
};

export default AddLead;
